import Leads from '../SuperAdmin/Leads';
export default Leads;
